import { Link } from "@remix-run/react";
import { LEGAL_LINKS } from "@/app/utils/constants";

export function Footer() {
  return (
    <footer className="w-full border-t bg-background py-6 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-center gap-4 text-sm text-muted-foreground">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            <Link
              to={LEGAL_LINKS.PRIVACY_POLICY}
              className="hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
            <span className="text-muted-foreground/50">•</span>
            <Link
              to={LEGAL_LINKS.DPA}
              className="hover:text-foreground transition-colors"
            >
              Data Processing Agreement
            </Link>
            <span className="text-muted-foreground/50">•</span>
            <Link
              to={LEGAL_LINKS.TERMS}
              className="hover:text-foreground transition-colors"
            >
              Terms and Conditions
            </Link>
          </div>
          <p className="text-xs text-muted-foreground/70">
            © {new Date().getFullYear()} AiAuditBuddy by Solviqom GmbH. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
